import * as Long from "long";
import { ofType } from "redux-observable";
import { from, of } from "rxjs";
import { switchMap } from "rxjs/operators";
import { IdErrorCore } from "../../../constants/IdErrorCore";
import { selectPlayerInfo, selectPlayerName } from "../../../selectors/selectPlayerInfo";
import { selectRankEntry, selectRankingSelectedLanguage } from "../../../selectors/selectRankInfo";
import { StatusCode } from "../../../utils/network/generated/protoTypes";
import { utilRanking } from "../../../utils/utilRanking";
import { actionErrorThrowError } from "../../errors/actionError";
import { actionPlayerXpHighScoresPositionRequest, actionPlayerXpSelfScoreReceived, TypeActionRanking, } from "../actionRanking";
export var epicPlayerXpRankingByName = function (action$, state$, deps) {
    return action$.pipe(ofType(TypeActionRanking.PlayerXpHighSocresNameRequest), switchMap(function (action) {
        var state = state$.value;
        var name = action.nameSearch ? action.nameSearch : selectPlayerName(state).name;
        var language = selectRankingSelectedLanguage(state);
        var url = utilRanking.getRankingPlayerXpUrlByName(name, language ? language.languageCode : undefined);
        return utilRanking.ajaxGetRequest(url);
    }), switchMap(function (res) {
        if (res == undefined) {
            var highScores = selectRankEntry(state$.value);
            if (highScores && highScores.length === 0) {
                return of(actionPlayerXpHighScoresPositionRequest(1));
            }
            return of(actionErrorThrowError(IdErrorCore.TextErrors, StatusCode.NAME_INVALID));
        }
        var playerId = selectPlayerInfo(state$.value).playerId;
        var actions = [];
        if (res) {
            if (res.id && Long.fromValue(res.id).equals(playerId)) {
                actions.push(actionPlayerXpSelfScoreReceived(res));
            }
            actions.push(actionPlayerXpHighScoresPositionRequest(res.position || 1));
        }
        return from(actions);
    }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/ranking/epics/epicPlayerXpRankingByName.ts
// module id = 2121
// module chunks = 3